export default __webpack_public_path__ + "static/media/23A8C1A0-0883-497B-9D34-F15A05B1CEB8_1_105_c.da06f18b.jpeg";